import { useState, useEffect, useCallback } from 'react';
import {
  IContentData,
  fetchContentData,
  invalidateCache,
  getVideosByCategory,
  getImagesByCategory,
  getAudiosByCategory,
  getYoutubeFeeds,
  getAllMediaFlat,
} from '../services/contentService';

export function useContentData() {
  const [data, setData] = useState<IContentData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const result = await fetchContentData();
      setData(result);
      setError(null);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const reload = useCallback(() => {
    invalidateCache();
    load();
  }, [load]);

  return {
    data,
    loading,
    error,
    reload,
    videoGroups: data ? getVideosByCategory(data) : [],
    imageGroups: data ? getImagesByCategory(data) : [],
    audioGroups: data ? getAudiosByCategory(data) : [],
    youtubeFeeds: data ? getYoutubeFeeds(data) : [],
    allMediaFlat: data ? getAllMediaFlat(data) : [],
  };
}
